import { render, staticRenderFns } from "./LawLedesTypeForm.vue?vue&type=template&id=10008811&"
import script from "./LawLedesTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawLedesTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesTypeForm.vue?vue&type=style&index=0&id=10008811&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports